/* DATI STAMPA PROPOSAL */
export const CONFERMA_STAMPA_PROPOSAL = 'CONFERMA_STAMPA_PROPOSAL';
export const INVIO_EMAIL_PROPOSAL     = 'INVIO_EMAIL_PROPOSAL';
export const UPDATE_NUMERO_PROPOSTA   = 'UPDATE_NUMERO_PROPOSTA';